import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileLayout from "../components/MobileLayout";
import AuthForm from "../components/auth/AuthForm";
import { useAuth } from "../contexts/AuthContext";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const Register: React.FC = () => {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRegister = async (data: {
    email: string;
    password: string;
    name?: string;
  }) => {
    if (!data.name) {
      setError("Name is required for registration");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await signup(data.email, data.password, data.name);
      navigate("/");
    } catch (error) {
      console.error("Registration failed:", error);

      const errorMessage =
        error instanceof Error
          ? error.message
          : "Registration failed. Please try again.";

      setError(
        errorMessage ===
          "This email address is already registered. Please try a different one."
          ? errorMessage
          : errorMessage
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MobileLayout title="Create Account">
      <div className="py-4">
        <div className="text-center">
          <h2 className="text-3xl font-garamond text-brand-primary">
            Welcome to Luminous
          </h2>
          <p className="mt-2 text-gray-600 dark:text-grey-300">
            Please create your account
          </p>
        </div>

        <AuthForm
          mode="register"
          onSubmit={handleRegister}
          error={error || undefined}
          isLoading={isLoading}
        />

        <div className="text-center font-garamond">
          <span className="text-gray-600 dark:text-grey-300">
            Already have an account?{" "}
          </span>
          <Link to="/login" className="text-brand-primary hover:underline">
            Sign in
          </Link>
        </div>

        <div className="text-center mt-4 mb-2">
          <div className="mx-auto max-w-xs px-4 py-2 bg-amber-50 border border-amber-100 rounded-md">
            <p className="text-amber-700 text-xs">
            This login is separate from rupertspira.com

            </p>
          </div>
        </div>

        {/* About Link */}
        <div className="mt-8 pt-4 border-t border-brand-primary/10">
          <div className="flex items-center justify-center">
            <Link
              to="/about"
              className="group flex items-center space-x-2 text-gray-500 dark:text-grey-300 hover:text-brand-primary dark:hover:text-brand-primary transition-colors duration-300 font-garamond"
            >
              <span>About Luminous</span>
              <ChevronRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </div>
        </div>
      </div>
    </MobileLayout>
  );
};

export default Register;
